import { render, staticRenderFns } from "./ManageCustomer.vue?vue&type=template&id=3b303fda&scoped=true"
import script from "./ManageCustomer.vue?vue&type=script&lang=js"
export * from "./ManageCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b303fda",
  null
  
)

export default component.exports